export const CStatsFragments = {
  field: `
    fragment stats on stats_MatrixField {
      ... on stats_main_Entry {
        id
        typeHandle
        idName
        badgeCopy
        badgeHyperlink {
          type
          url
          text
          target
        }
      }
      ... on stats_stat_Entry {
        id
        typeHandle
        number
        text
        button {
          type
          url
          text
          target
        }
        badgeCopy
        badgeHyperlink {
          type
          url
          text
          target
        }
      }
    }
  `,
}
